window.addEventListener("load", function () {
  // if ($(window).width() > 999) {
  //   const video = document.getElementsByTagName("video")[0];
  //   const sources = video.getElementsByTagName("source");
  //   const srcVideo = $(".MJ__loadVideo").data("video");
  //   sources[0].src = srcVideo;
  //   video.load();
  // }
});
